import React from 'react';
import '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faReact,
  faAws,
} from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';

const labelsFirst = [
  'React',
  'Angular 2',
  'TypeScript',
  'JavaScript',
  'HTML5',
  'CSS3',
  'SASS',
  'Django',
  'NativeWind',
  'TailwindCSS',
  'React Native ',
  'Redux/Toolkit',
  'Saga',
  'MaterialUI',
  'Ionic',
  'NextJS',
  '...',
];

const labelsSecond = [
  'Google Cloud',
  'Redis',
  'Memcached',
  'Azure',
  'Nginx',
  'Git',
  'GitHub Actions',
  'Apache Kafka',
  'Prometheus',
  'AWS',
  'Linux',
  '...',
];

const labelsThird = [
  'Java',
  'Node.js',
  'Python',
  'Spring Boot',
  'Express.js',
  'FastAPI',
  'PostgreSQL',
  'MySQL',
  'MongoDB',
  'CI/CD Pipelines',
  'AWS Lambda',
  '...',
];

function Expertise() {
  return (
    <div className="container" id="expertise">
      <div className="skills-container">
        <h1>Expertise</h1>
        <div className="skills-grid">
          <div className="skill">
            <FontAwesomeIcon icon={faReact} size="3x" />
            <h3>Full Stack Web Development</h3>
            <p>
              I have built a diverse array of web applications from scratch
              using modern technologies such as React and AngularJS. I have a
              strong proficiency in the SDLC process and frontend + backend
              development.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsFirst.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faAws} size="3x" />
            <h3>System Architecture & Design</h3>
            <p>
              I design scalable and resilient system architectures, with a
              strong focus on large-scale distributed microservices. My
              expertise lies in crafting high-performance solutions that ensure
              reliability, fault tolerance, and seamless scalability. I excel in
              system optimization, data consistency, and event-driven
              architectures, ensuring efficiency at every level.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsSecond.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>

          <div className="skill">
            <FontAwesomeIcon icon={faDatabase} size="3x" />
            <h3>Back-end Systems Development</h3>
            <p>
              I develop robust and high-performance backend architectures that
              power scalable applications. My expertise spans designing
              efficient APIs, optimizing database performance, and implementing
              secure, fault-tolerant systems. I focus on building maintainable
              and modular backend solutions that ensure seamless data flow,
              reliability, and efficiency.
            </p>
            <div className="flex-chips">
              <span className="chip-title">Tech stack:</span>
              {labelsThird.map((label, index) => (
                <Chip key={index} className="chip" label={label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Expertise;
